import React, { useEffect, useRef, useState } from "react";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../../renderer/StyleRenderer";
import Grid from "../../../Grid";

const ChargeList = ({ type, charges, currencyCode }) => {
  const gridRef = useRef();
  const [chargeList, setChargeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const mappedCharges = [];
      const formatter = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currencyCode,
      });
      for (let charge of charges) {
        mappedCharges.push({
          ...charge,
          chdTotal: formatter.format(charge.chdTotal),
        });
      }
      setChargeList(mappedCharges);
      setIsLoading(false);
    })();
  }, [charges, currencyCode]);

  return (
    <div className="ui segment" style={{width:"80vw"}}>
      <h4 className="ui dividing header">
        {type === 1 ? "Transporter" : "Customer"} Charges
      </h4>
      <Grid
        ref={gridRef}
        heading="Pick the jobs for charge approval"
        isLoading={isLoading}
        wrapText={false}
        searchable={true}
        config={[
          {
            headerName: "Code",
            field: "chdCode",
          },
          { headerName: "Charge Type", field: "chdChargeTypeValue" },
          { headerName: "Charge", field: "chdChacrgesValue" },
          {
            headerName: "Description",
            field: "chdDescription",
            cellRenderer: ResizableScrollingTextRenderer,
          },
          { headerName: "Exchange Currency", field: "chdCurCode" },
          { headerName: "Exchange Rate", field: "chdExcRate" },
          { headerName: "Value", field: "chdValue" },
          { headerName: "Qty", field: "chdQty" },
          { headerName: "Total", field: "chdTotal" },
          {
            headerName: "Status",
            field: "chdStatusValue",
            cellRenderer: StatusCellStyle,
          },
          {
            headerName: "Active",
            field: "chdActiveValue",
            cellRenderer: ActiveCellStyle,
          },
        ]}
        content={chargeList}
      />
    </div>
  );
};

export default ChargeList;
